import clsx from "clsx"
import { useContext, useEffect, useMemo, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useAuth } from "shared/auth"
import { MediaDesktop, MediaMobile, MediaTablet } from "../../../api/const/MediaQuery"
import useMediaQuery from "../../../hook/useMediaQuery"
import { AppGeneralContext } from "../../../shared/GeneralContext/GeneralContext"
import { AnchorMenu, Button } from "../../atoms"
import './DropdownMenu.css'
import { LoginType } from "components/types/Context"


type DropProps = {
    isPlatform: boolean
}

export const DropdownMenu = ({ isPlatform }: DropProps) => {
    const { menuIsOpen, setMenuIsOpen, loginType } = useContext(AppGeneralContext)
    const { logout } = useAuth()

    const desktop = useMediaQuery(MediaDesktop);
    const tablet = useMediaQuery(MediaTablet);
    const mobile = useMediaQuery(MediaMobile)
    const navigate = useNavigate();
    const [visible, setVisible] = useState<boolean>(false)
    const location = useLocation()


    useEffect(() => {
        if (!menuIsOpen) {
            setVisible(false);
        } else {
            setVisible(true)
        }
    }, [menuIsOpen])


    const RenderLoginBtn = () => {
        return (
            <Button className='mb-2'
                background='var(--white)'
                uppercase
                text='log in'
                onClick={() => {
                    navigate("/login");
                    setMenuIsOpen(false)
                }} />
        )
    }

    const RenderGetStartedBtn = () => {
        return (
            <Button className='mb-2'
                color='var(--white)'
                background='var(--primary)'
                borderColor='var(--primary)'
                fontWeight={'800'}
                uppercase
                primary
                text='Register now'
                onClick={() => {
                    const registerPath = loginType === LoginType.startup ? '/startup' : ''
                    navigate(`/getStarted${registerPath}`)
                    setMenuIsOpen(false)
                }} />
        )
    }

    const RenderLogoutBtn = () => {
        return (<Button className='mb-2'
            color='var(--white)'
            background='var(--primary)'
            borderColor='var(--primary)'
            fontWeight={'800'}
            uppercase
            primary
            text='logout'
            onClick={() => {logout(); navigate("/login"); setMenuIsOpen(false) }} />)

    }


    const showButton = useMemo(() => {

        if (location.pathname === '/' ||
            location.pathname.toLowerCase().includes('/login') ||
            location.pathname.toLowerCase().includes('/getstarted')) {

            if (mobile || tablet) {
                return (
                    <>
                        <RenderGetStartedBtn />
                    </>
                )
            }
            return null
        }

        return <RenderLogoutBtn />

    }, [location.pathname, mobile, tablet, desktop])




    return (
        <div className={clsx("mobile_menu d-flex p-0 m-0 ",
            { "dropMenu-platform ": !tablet && isPlatform },
            { "dropMenu-website ": tablet || !isPlatform }
        )}>
            <div className={menuIsOpen ? " mobile_menu_open_platform  container " : "  mobile_menu_close"}>
                <div className="  d-flex mb-5 flex-column align-items-start justify-content-between " style={visible ? { opacity: 1, transition: "opacity 0.8s" } : { opacity: 0, transition: "opacity 0.8s" }}>
                    {menuIsOpen && <AnchorMenu />}
                    {menuIsOpen &&
                        <div className="d-flex flex-column">
                            {showButton}
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}